import { useImageAlts } from "@/hooks/use-image-alts";
import { cn } from "@/lib/utils";

/** «Foto: Kvinnheringen» – accepts a bare name or a string that already starts with Foto:. */
export const creditLabel = (credit) => {
  const c = (credit || "").trim().replace(/^foto\s*:\s*/i, "");
  return c ? `Foto: ${c}` : "";
};

/**
 * The photographer's credit for one picture, read from Admin → Bilete. Renders nothing when there is none.
 * `overlay` pins it to the bottom-right corner of the picture (parent must be `relative`); otherwise it is a quiet inline label.
 */
export const PhotoCredit = ({ src, credit, overlay = false, className, testId = "photo-credit" }) => {
  const { creditFor } = useImageAlts();
  const label = creditLabel(credit ?? creditFor(src));
  if (!label) return null;
  return (
    <span className={cn(overlay ? "photo-credit-overlay" : "photo-credit", className)} data-testid={testId}>{label}</span>
  );
};
